import { __decorate } from "tslib";
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import detailsLevel from '@blade/common/pages/alert-details/components/details-level.vue';
import detailsType from '@blade/common/pages/alert-details/components/details-type.vue';
import detailsThreshold from '@blade/common/pages/alert-details/components/details-threshold.vue';
import detailsFace from '@blade/common/pages/alert-details/components/details-face.vue';
import detailsGatherScatter from '@blade/common/pages/alert-details/components/details-gather-scatter.vue';
import detailsSocialDistance from '@blade/common/pages/alert-details/components/details-social-distance.vue';
import detailsConfidence from '@blade/common/pages/result-details/components/details-confidence.vue';
import detailsSnapArea from '@blade/common/pages/alert-details/components/details-snap-area.vue';
import detailsStatus from '@blade/common/pages/alert-details/components/details-status.vue';
import detailsOperator from '@blade/common/pages/alert-details/components/details-operator.vue';
import DetailsRightBottom from '@blade/common/pages/result-details/components/details-right-bottom.vue';
import lang from '@blade/common/pages/alert-details/lang/index';
import fireDetection from '@blade/common/pages/alert-details/components/fire-detection.vue';
import { getTaskTargetStr } from '@blade/common/pages/result-details/common/util';
import { confidenceShowList } from '@blade/common/pages/result-details/common/config';
let detailsRight = class detailsRight extends Vue {
    sourceImage;
    detailsProps;
    detailsIndex;
    showPath;
    maxNum;
    filterImgLv;
    componentName = '';
    isShowConfidence = false;
    confirmDialog() { }
    details = {};
    onDetails() {
        this.details = this.detailsProps;
        this.getComponentName();
    }
    getComponentName() {
        this.componentName = getTaskTargetStr('incidentType', 'incidentComponent', this.details.incidentType);
        this.showConfidence(this.componentName);
    }
    closeDetails() {
        this.$emit('close-details');
    }
    addRoute(checkRoute, flag, index) {
        this.$emit('add-route', checkRoute, flag, index);
    }
    deleteRoute(routeData, flag, index) {
        this.$emit('deleted-route', routeData, flag, index);
    }
    showConfidence(val) {
        if (this.componentName && confidenceShowList.includes(val)) {
            this.isShowConfidence = true;
        }
        else {
            this.isShowConfidence = false;
        }
    }
    get getValid() {
        let val = this.details.incidentType;
        let newShow = true;
        switch (val) {
            case 'INCIDENT_CROWD':
                newShow = false;
                break;
            case 'INCIDENT_QUEUE_TIMING':
                newShow = false;
                break;
            case 'INCIDENT_QUEUE_COUNTING':
                newShow = false;
                break;
            case 'INCIDENT_OFF_DUTY':
                newShow = false;
                break;
        }
        return newShow;
    }
};
__decorate([
    Prop()
], detailsRight.prototype, "sourceImage", void 0);
__decorate([
    Prop()
], detailsRight.prototype, "detailsProps", void 0);
__decorate([
    Prop()
], detailsRight.prototype, "detailsIndex", void 0);
__decorate([
    Prop()
], detailsRight.prototype, "showPath", void 0);
__decorate([
    Prop()
], detailsRight.prototype, "maxNum", void 0);
__decorate([
    Prop()
], detailsRight.prototype, "filterImgLv", void 0);
__decorate([
    Emit('confirmDialog')
], detailsRight.prototype, "confirmDialog", null);
__decorate([
    Watch('detailsProps', { immediate: true, deep: true })
], detailsRight.prototype, "onDetails", null);
detailsRight = __decorate([
    Component({
        name: 'detailsRight',
        components: {
            detailsLevel,
            detailsType,
            detailsThreshold,
            detailsFace,
            detailsGatherScatter,
            detailsSocialDistance,
            detailsSnapArea,
            detailsStatus,
            detailsOperator,
            DetailsRightBottom,
            fireDetection,
            detailsConfidence,
        },
        i18n: {
            messages: lang,
        },
    })
], detailsRight);
export default detailsRight;
